// extracted by mini-css-extract-plugin
export default {"Dropdown":"s0-ia","skeleton-progress":"ig2jI"};